<template>
  <div>
    <div class="row mt-2" v-if="control.type !== 'checkbox'">
      <div class="col-md-12">
        <div class="form-group">
          <label
            v-back-to-default="[
              $parent.inheritedControlInfo,
              control,
              'defaultValue',
              $parent.backToDefault
            ]"
          >
            Default value
          </label>
          <input
            type="text"
            class="form-control"
            @blur="editSidebar"
            v-model="control.defaultValue"
          />
        </div>
      </div>
    </div>
    <div class="row mt-2" v-if="control.type !== 'checkbox'">
      <div class="col-md-12">
        <div class="form-group">
          <label>Sum Or Total Expression</label>
          <input type="checkbox"  v-model="control.sum" @change="editSidebar" />
        </div>
      </div>
    </div>
    <div class="row mt-2" v-if="control.sum">
      <div class="col-md-12">
        <div class="form-group">
          <label>Field To Total</label>
          <treeselect
            @select='control.groupBy = null;editSidebar()'
            v-model="control.sumField"
            :multiple="false"
            :options="fields"
          />
        </div>
      </div>
    </div>
    <div class="row mt-2" v-if="control.sum">
      <div class="col-md-12">
        <div class="form-group">
          <label>Group By</label>
          <treeselect
            @select='control.expression = calcEx;editSidebar()'
            v-if="groupBy"
            v-model="control.groupBy"
            :multiple="false"
            :options="groupBy"
          />
        </div>
      </div>
    </div>

    <div class="row mt-2"  v-if="control.type !== 'checkbox'">
      <div class="col-md-12">
        <div class="form-group">
          <label
            v-back-to-default="[
              $parent.inheritedControlInfo,
              control,
              'expression',
              $parent.backToDefault
            ]"
          >
            Calculated Expression
          </label>
          <textarea type="text" class="form-control" v-model="control.expression" @blur="editSidebar"></textarea>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <!-- <div class="form-group">
          <label
            v-back-to-default="[
              $parent.inheritedControlInfo,
              control,
              'label',
              $parent.backToDefault
            ]"
          >
            Control label
          </label>
          <input type="text" class="form-control" v-model="control.label" />
        </div> -->
        <div class="form-group">
          <label>
            <input type="checkbox" v-model="control.labelBold" @change="editSidebar" />
            <span
              v-back-to-default="[
                $parent.inheritedControlInfo,
                control,
                'labelBold',
                $parent.backToDefault
              ]"
            />
            <span>Bold</span>
          </label>
          <label>
            <input type="checkbox" v-model="control.labelItalic" @change="editSidebar" />
            <span
              v-back-to-default="[
                $parent.inheritedControlInfo,
                control,
                'labelItalic',
                $parent.backToDefault
              ]"
            />
            <span>Italic</span>
          </label>
          <label>
            <input type="checkbox" v-model="control.labelUnderline" @change="editSidebar" />
            <span
              v-back-to-default="[
                $parent.inheritedControlInfo,
                control,
                'labelUnderline',
                $parent.backToDefault
              ]"
            />
            <span>Underline</span>
          </label>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { mapState } from "vuex";
import db from "@/services/db";
export default {
  name: "BaseStyleComponent",
  props: {
    control: {
      type: Object
    },
    editSidebar: {
      type: Function
    }
  },
  computed: {
    ...mapState([
      "currentDash",
      "currentTab",
      "dataGrid_options",
      "models_dashboardModel"
    ]),
    fields() {
      var fieldTree = [];
      var f = this.dataGrid_options;

      Object.keys(f).forEach(function(key) {
        var fieldsKey = f[key].meta;
        var name = f[key].title;

        var objectFields = [];
        Object.keys(fieldsKey).forEach(function(k) {
          var label = name + " / " + fieldsKey[k].displayName;

          var id = key + "." + k;
         // `$sum('transactions.quantity', 'item', rowData.item)`
          objectFields.push({ id, label });
        });
        fieldTree.push.apply(fieldTree, objectFields);
      });
      return fieldTree;
    },
    calcEx() {


      let ex = `$sum('${this.control.sumField}', '${this.control.groupBy}', rowData.${this.control.groupBy}) `
      //this.control.expression = ex

      return ex
    },
    groupBy() {
      var fieldTree = [];
      var f = this.dataGrid_options;
      let gridText = this.control.sumField || ''
      let thisGrid = gridText.split('.')[0]

      if (!this.control.sumField) return


        var fieldsKey = f[thisGrid].meta;
        var name = f[thisGrid].title;

        var objectFields = [];
        Object.keys(fieldsKey).forEach(function(k) {
          // console.log(fieldsKey[k])
          if (fieldsKey[k].type == 'lookup'){
            // console.log(fieldsKey[k])
            var label = fieldsKey[k].displayName;

            var id = k;
          // `$sum('transactions.quantity', 'item', rowData.item)`
            fieldTree.push({label:label, id:id});

          }

        });
        fieldTree.push( objectFields);

      return fieldTree;
    }
  },
};
</script>

<style scoped>
</style>
